<template>
  <o-dialog
    ref="dialog"
    :title="$t('components.schedule.actions.create.title')"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' }
    ]"
  >
    <div class="flex flex-col space-y-3 text-left mt-3">
      <o-panel-link v-if="isEmployeeType" path="/appointment/create?type=single" class="flex items-center space-x-3 group hover:bg-gray-50 rounded-lg py-2 px-3 dark:hover:bg-gray-900/50" :props="linkProps" @click="handleClick">
        <o-icon icon="reservation" class="text-gray-800 group-hover:text-primary-600 dark:text-gray-100 dark:group-hover:text-primary-400" />
        <div>
          <p class="text-sm text-gray-700 group-hover:text-primary-600 font-medium dark:text-gray-200 dark:group-hover:text-primary-400">
            {{ $t('general.appointment') }}
          </p>
          <p class="text-sm text-gray-500 dark:text-gray-400 group-hover:text-primary-600 dark:group-hover:text-primary-400">
            {{ $t('schedule.createNewCustomerAppointment') }}
          </p>
        </div>
      </o-panel-link>

      <o-panel-link v-if="isEmployeeType" path="/appointment/create?type=group" class="flex items-center space-x-3 group hover:bg-gray-50 rounded-lg py-2 px-3 dark:hover:bg-gray-900/50" :props="linkProps" @click="handleClick">
        <o-icon icon="reservation" class="text-gray-800 group-hover:text-primary-600 dark:text-gray-100 dark:group-hover:text-primary-400" />
        <div>
          <p class="text-sm text-gray-700 group-hover:text-primary-600 font-medium dark:text-gray-200 dark:group-hover:text-primary-400">
            {{ $t('general.class') }}
          </p>
          <p class="text-sm text-gray-500 dark:text-gray-400 group-hover:text-primary-600 dark:group-hover:text-primary-400">
            {{ $t('components.schedule.actions.create.groupClass') }}
          </p>
        </div>
      </o-panel-link>

      <a class="flex items-center space-x-3 group hover:bg-gray-50 rounded-lg py-2 px-3 cursor-pointer dark:hover:bg-gray-900/50" :props="linkProps" @click="handleCreateBreak">
        <o-icon icon="reservation" class="text-gray-800 group-hover:text-primary-600 dark:text-gray-100 dark:group-hover:text-primary-400" />
        <div>
          <p class="text-sm text-gray-700 group-hover:text-primary-600 font-medium dark:text-gray-200 dark:group-hover:text-primary-400">
            {{ $t('schedule.break') }}
          </p>
          <p class="text-sm text-gray-500 dark:text-gray-400 group-hover:text-primary-600 dark:group-hover:text-primary-400">
            {{ $t('components.schedule.actions.create.employeeBreak') }}
          </p>
        </div>
      </a>
    </div>
  </o-dialog>
</template>

<script setup lang="ts">
interface Emits {
  (e: 'createBreak', value: any): void
}

const emit = defineEmits<Emits>()

const dialog = ref<any>()
const date = ref<any>(null)
const employee = ref<any>(null)
const startTime = ref<any>(null)

const linkProps = computed(() => {
  return {
    presets: {
      employee: employee.value,
      date: date.value,
      startTime: Number(startTime.value),
    },
  }
})

const isEmployeeType = computed(() => {
  return employee.value?.isEmployeeType
})

const open = (emp: any, d: any, st: any) => {
  employee.value = emp
  date.value = d
  startTime.value = st

  dialog.value.open()
}

const handleClick = () => {
  dialog.value.close()
}

const handleCreateBreak = () => {
  const options = {
    employee: employee.value,
    date: date.value,
    time: startTime.value,
  }

  emit('createBreak', options)
  dialog.value.close()
}

defineExpose({
  open,
})
</script>
